export default [
    {
        path: "/",
        title: "Canlı sports | Canlı Bahis",
        description: "",
        keywords: ""
    },
];
